import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";

const values = [
  { icon: "ri-cup-fill", title: "轻松至上", desc: "我们相信，快乐不需要复杂。一杯快乐水、一本漫画，就是最好的放松方式。" },
  { icon: "ri-heart-3-line", title: "真诚推荐", desc: "每一部漫画、每一份快乐水组合，都来自编辑团队的真实体验与用心筛选。" },
  { icon: "ri-moon-line", title: "陪伴日常", desc: "从午休摸鱼到周末放松，可乐漫画希望能成为你每一天里小小的快乐来源。" },
];

const principles = ["内容真实可读", "推荐经过亲测", "尊重每位读者", "拒绝无效刷屏"];

const testimonials = [
  { name: "小夏", text: "可乐漫画配可乐的概念太对味了，快乐水组合让我重新爱上追更。" },
  { name: "老K", text: "肥宅快乐套餐给了我很多搭配灵感，周末摸鱼终于不无聊了。" },
  { name: "Nana", text: "榜单更新很认真，推荐的漫画质量都蛮高的，还会继续追下去。" },
];

export default function About() {
  return (
    <Layout>
      <title>关于我们 - 了解可乐漫画的品牌与理念 | 可乐漫画</title>
      <meta name="description" content="了解可乐漫画：一个关于配可乐看漫画、快乐水组合与肥宅快乐套餐的轻松内容平台。我们相信快乐追更、周末放松与摸鱼本身就是生活的一部分。" />
      <meta name="keywords" content="可乐漫画,关于我们,快乐水组合,肥宅快乐套餐,追更配零食" />
      <link rel="canonical" href="https://lazymix.github.io/about" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "关于可乐漫画",
          url: "https://lazymix.github.io/about",
          description: "关于可乐漫画品牌介绍、定位、理念与内容原则。",
        })}
      </script>

      <section className="relative flex min-h-[320px] w-full items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=playful%20flat%20cartoon%20illustration%20of%20cola%20bottles%2C%20manga%20books%20and%20cheerful%20characters%20relaxing%20together%2C%20warm%20cream%20background%20with%20caramel%20orange%20and%20red%20accents%2C%20soft%20rounded%20shapes%2C%20cozy%20and%20joyful%20atmosphere&width=1600&height=700&seq=about-hero&orientation=landscape"
          alt="可乐漫画品牌轻松的插画氛围"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 to-foreground-950/60" />
        <div className="relative z-10 mx-auto w-full max-w-3xl px-4 py-16 text-center">
          <h1 className="font-heading text-3xl text-background-50 md:text-5xl">关于可乐漫画</h1>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
            一个关于"配可乐看漫画"的轻松内容平台。我们把快乐水组合、肥宅快乐套餐和追更配零食，
            整理成一篇篇温暖、实用又有趣的内容，陪你度过每个放松时刻。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="text-sm font-medium text-accent-600">品牌定位</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">快乐追更，从一杯快乐水开始</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              可乐漫画诞生于一个朴素的念头：忙碌的生活里，我们应该拥有属于自己的放松时刻。无论是午休摸鱼、
              深夜独处，还是周末窝在沙发里，一杯快乐水配上一部好漫画，就是最简单也最珍贵的快乐。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              所以我们把漫画推荐、快乐水组合和肥宅快乐套餐做成有趣实用的内容，希望每一位读者都能在这里找到
              属于自己的追更节奏和放松方式。
            </p>
            <Link
              to="/list"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              去追更榜单看看
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200 bg-background-100 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className={`${v.icon} text-xl`} style={{ width: 20, height: 20 }} />
                </span>
                <h3 className="mt-3 text-base font-medium text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
            <div className="rounded-lg border border-dashed border-primary-300 bg-primary-100/60 p-6">
              <h3 className="text-base font-medium text-primary-800">发展理念</h3>
              <p className="mt-2 text-sm leading-relaxed text-primary-900">
                不追求大而全，只做好"配可乐看漫画"这一件快乐的小事，并把它做到足够温暖。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <span className="text-sm font-medium text-accent-600">内容原则</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">我们认真对待每一条内容</h2>
          </div>
          <div className="mt-10 grid grid-cols-2 gap-5 lg:grid-cols-4">
            {principles.map((p, i) => (
              <div key={p} className="rounded-lg border border-background-200 bg-background-50 p-6 text-center">
                <div className="font-heading text-3xl text-primary-500">0{i + 1}</div>
                <div className="mt-2 text-sm font-medium text-foreground-950">{p}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-medium text-accent-600">读者口碑</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">来自同好的声音</h2>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-lg border border-background-200 bg-background-100 p-6">
              <blockquote className="text-sm leading-relaxed text-foreground-800">"{t.text}"</blockquote>
              <figcaption className="mt-4 text-sm font-medium text-foreground-950">— {t.name}</figcaption>
            </figure>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 rounded-full border border-primary-300 px-6 py-3 text-sm font-medium text-primary-700 whitespace-nowrap transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            想和我们聊聊？联系我们
            <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
          </Link>
        </div>
      </section>
    </Layout>
  );
}